import React from 'react';
import moment from 'moment';

import CardGrayBanner from 'buyside/components/presentation/CardGrayBanner/cardGrayBanner';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';

import CheckIcon from 'buyside/svgs/check.svg';

import { jobVaultPostingUrl, jobVaultIndexUrl, jobVaultNewUrl } from 'buyside/util/urlHelper';

import { ActivityFeedJobPostingFragment } from 'interfaces/graphql-typings';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';

import styles from './jobVaultCardStyles.scss';

const JobVaultCard: React.FC<{
  eventVerb?: string;
  jobPosting: ActivityFeedJobPostingFragment;
}> = ({ eventVerb, jobPosting }): React.ReactElement => {
  const jobFilled = eventVerb !== 'PUBLISH_JOB_POSTING';
  const { id, title, description, sectors, city, postedAt, updatedAt, employer } = jobPosting;

  const banner = [
    { title: 'Location', value: city ? city : 'N/A' },
    { title: 'Strategy', value: employer?.strategy },
    { title: 'Aum Range', value: employer?.aumRange },
    { title: 'Type', value: employer?.fundType }
  ];

  let truncatedDescription = description;
  if (description && description.length > 400) {
    truncatedDescription = description.substring(0, 350) + '...';
  }

  return (
    <div>
      <div className={styles.jobVaultCardHeader}>
        <h4>{title}</h4>
        {sectors && (
          <div className={styles.infoSection}>
            Sectors: <strong>{sectors}</strong>
          </div>
        )}
        <div className={styles.infoSection}>
          <span className={styles.postedArea}>
            Posted:{' '}
            <strong>{postedAt ? moment(new Date(postedAt)).format('MMM D, YYYY') : 'N/A'}</strong>
          </span>
          {jobFilled && (
            <span>
              Filled:{' '}
              <strong>
                {updatedAt ? moment(new Date(updatedAt)).format('MMM D, YYYY') : 'N/A'}
              </strong>
            </span>
          )}
        </div>
      </div>
      <CardGrayBanner displayItems={banner} />
      <div className={styles.jobDescription}>
        {jobFilled ? (
          <div>
            <p>{truncatedDescription}</p>
          </div>
        ) : (
          <a href={jobVaultPostingUrl(id)}>
            <p>{truncatedDescription}</p>
          </a>
        )}
      </div>
      {jobFilled ? (
        <div className={styles.positionFilled}>
          <div className={styles.filledItem}>
            <CheckIcon className={styles.checkIcon} /> Position Filled
          </div>
          <div className={styles.filledItem}>
            <Link to={jobVaultIndexUrl()} className={styles.filledLink}>
              See Open Positions
            </Link>
          </div>
          <div className={styles.filledItem}>
            <Link to={jobVaultNewUrl()} className={styles.filledLink}>
              Post a New Position
            </Link>
          </div>
        </div>
      ) : (
        <div className={styles.navArea}>
          <Button
            text="View Job Posting"
            type={BUTTON_TYPES.PRIMARY}
            size={BUTTON_SIZES.SMALL}
            faIcon={faBriefcase}
            url={jobVaultPostingUrl(id)}
          />
        </div>
      )}
    </div>
  );
};

export default JobVaultCard;
